export default {
    // 发送验证码
    sendSms: {
        method: 'post',
        url: "/app/loginApi/signInSendSms",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
    // 验证码登录
    codeLogin: {
        method: 'post',
        url: "/app/loginApi/codeSignin",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
    // 密码登录
    pwdLogin: {
        method: 'post',
        url: "/app/loginApi/login",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
    // 获取企业信息列表
    getCompList: {
        method: 'post',
        url: "/app/loginApi/getCompList",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
    // 获取企业信息列表
    newgetList: {
        method: 'post',
        url: "/app/voice/newgetList",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
    // 获取用户信息
    getUserInfo: {
        method: 'post',
        url: "/app/voice/getUser",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
    // 微信鉴权
    clientconfig: {
        method: 'post',
        url: "/app/voice/clientconfig",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
    // 退出登录
    loginout: {
        method: 'post',
        url: "/app/loginApi/signOut",
        config: {
            hideLoading: true,
            hideMsg: true
        }
    },
}


// WEBPACK FOOTER //
// ./src/store/mutationTypes.js